import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ConstantesApp } from 'src/app/app.config/constantes-app';
import { Cliente } from 'src/app/app.domain.models/cliente';
import { Poliza } from 'src/app/app.domain.models/poliza';
import { ClienteApiService } from 'src/app/app.domain.services/cliente.api.service';
import { PolizaApiService } from 'src/app/app.modules/individual/domain.services/poliza.api.service';
import { DialogData } from 'src/app/core.models/modal/dialogData';
import { SesionService } from 'src/app/core.services/sesion.service';
import { Utilidades } from 'src/app/core.utilidades/utilidades';

@Component({
    selector: 'app-modal-direccion-dialog',
    templateUrl: './modal-direccion-envio.component.html',
    styleUrls: ['./modal-direccion-envio.component.scss'],
})
export class ModalDireccionEnvioComponent {

    cliente!: Cliente;
    poliza!: Poliza;

    mensajeValidacionForm: string = '';

    formDireccionEnvio: FormGroup;

    formulario: string = "envio-direccion";
    constructor(
        public dialogRef: MatDialogRef<ModalDireccionEnvioComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private clienteService: ClienteApiService,
        private polizaService: PolizaApiService,
        private sesion: SesionService,
        private translateService: TranslateService,
        private toastr: ToastrService,
        private cd: ChangeDetectorRef,
    ) {
        this.cliente = this.sesion.getCliente();
        this.poliza = this.sesion.getPoliza();

        this.formDireccionEnvio = new FormGroup({
            direccion: new FormControl(this.cliente.direccion, [Validators.required, Validators.maxLength(255), Validators.minLength(5)]),
            provincia: new FormControl(this.cliente.provincia, [Validators.required, Validators.maxLength(255), Validators.minLength(2)]),
            ciudad: new FormControl(this.cliente.ciudad, [Validators.required, Validators.maxLength(255), Validators.minLength(2)]),
            codigoPostal: new FormControl(this.cliente.codigoPostal, [Validators.required, Validators.maxLength(255), Validators.pattern(ConstantesApp.NUMEROS_ENTEROS_POSITIVOS)])
        });
    }

    getError(data: any) {
        let transMessageError = Utilidades.obtenerErrorFormControl(data, this.formulario);
        if (transMessageError != "") {
            return this.translateService.instant(transMessageError);
        }
        return "";
    }

    get getFormDireccionEnvio(): { [key: string]: AbstractControl } { return this.formDireccionEnvio.controls; }

    async cerrarModalEnvio() {
        if (this.formDireccionEnvio.valid) {
            
            if(!this.cliente.credencialId){
                const clienteConCredencial = await this.clienteService.crearCredencialCliente(this.cliente.id!);
                if(clienteConCredencial){
                    this.cliente.credencialId = clienteConCredencial.credencialId;
                }
            }

            this.cliente.direccion = this.formDireccionEnvio.controls["direccion"].value;
            this.cliente.provincia = this.formDireccionEnvio.controls["provincia"].value;
            this.cliente.ciudad = this.formDireccionEnvio.controls["ciudad"].value;
            this.cliente.codigoPostal = this.formDireccionEnvio.controls["codigoPostal"].value;

            const clienteRes = await this.clienteService.actualizar(this.cliente);
            if(clienteRes) {
                    this.cliente = clienteRes;
                    this.sesion.setCliente(this.cliente);
                    
                    this.poliza.cliente = this.cliente;
                    this.poliza.formalizado = true;
                    this.poliza.fechaFirma = new Date();
                    this.polizaService.actualizar(this.poliza)
                        .then((polizaRes: Poliza) => {
                            polizaRes.beneficiarioList = this.poliza.beneficiarioList;
                            this.sesion.setPoliza(polizaRes);
                            this.dialogRef.close('confirm');
                        });
            }

        } else {
            this.toastr.error(this.translateService.instant('form.generic.error.general'));
            this.formDireccionEnvio.markAllAsTouched();
            this.cd.detectChanges();
        }
    }

    cerrarModal() {
        this.dialogRef.close('cancel');
    }
}
